import marketingMultiParagraphFragmentRawString from '../MarketingMultiParagraphFragment.graphql'

export const marketingMultiParagraphFragmentString = marketingMultiParagraphFragmentRawString

export type MarketingMultiParagraphFragment = {
  __typename: 'MarketingMultiParagraph'
  id: string
  title: string
  content: string
  createdAt: string
  updatedAt: string
}

export const isMarketingMultiParagraphFragment = (
  fragment: any,
): fragment is MarketingMultiParagraphFragment =>
  fragment &&
  fragment.__typename === 'MarketingMultiParagraph' &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  typeof fragment.content === 'string' &&
  typeof fragment.createdAt === 'string' &&
  typeof fragment.updatedAt === 'string'
